/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownLeftIcon32Regular = forwardRef('ArrowADownLeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8.416 24.998 8.5 25h13a1 1 0 1 1 0 2h-13A3.5 3.5 0 0 1 5 23.5v-13a1 1 0 1 1 2 0v13c0 .028 0 .056.002.084l17.79-17.791a1 1 0 1 1 1.415 1.414l-17.79 17.79Z" })));
});
